import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Flex,
  Tag,
  Box,
  Text,
  Button,
  Heading,
  Stack,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  InputGroup,
  InputLeftElement,
  Input,
  FormLabel,
  Icon,
  Skeleton,
  SkeletonText,
  useToast,
  useDisclosure
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Paginate from "components/navigation/Paginate.js";
//import TextFilter from "components/filter/TextFilter";
import Card from "components/card/Card.js";
import {
  //GetAdminUsers,
  SearchUser,
  DeleteUser,
} from "services/userService";
import { checkprivileges } from "helpers/utils";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiArrowLeft, FiEye } from "react-icons/fi";
import { CalendarIcon } from "@chakra-ui/icons";
import { GetOrganizations } from "services/organizationService";
const { DateTime } = require("luxon");

const formatTime = (timestamp) => {
  const myDateTime = DateTime.fromISO(timestamp);
  return myDateTime.toLocaleString(DateTime.DATE_MED);
};

export default function Index() {
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isUserDrawerOpen, onOpen: onUserDrawerOpen, onClose: onUserDrawerClose } = useDisclosure();

  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const privileges = userState.hasOwnProperty("privileges") ? userState.privileges : [];
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [organization, setOrganization] = useState("");
  const [date, setDate] = useState("");
  const [organizationId, setOrganizationId] = useState("");

  const getOrganizations = async () => {
    try {
      setLoading(true);
      console.log(date);
      const filter = {
        date
      };
      const response = await GetOrganizations(filter, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setOrganizations(response?.data);
        setLoading(false);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const deleteUser = async () => {
    try {
      setLoading(true);
      const response = await DeleteUser(organizationId, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        toast({
          title: response.message || "User deleted successfully",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        getOrganizations();
        onClose();
      }
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      const searchData = {
        deleted: false,
        type: "admin",
        searchText
      };
      setLoading(true);
      const response = await SearchUser(searchData, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setOrganizations(response.data);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getOrganizations();
  }, [date]);

  useEffect(() => {
    !checkprivileges(privileges, ["Super", "Admin"]) && (toast({ title: "You are not allowed", status: "error", duration: 9000, position: "top-right", isClosable: true, }) && navigate("/admin/dashboard"));
    getOrganizations();
  }, []);

  return (
    <>
      <Drawer isOpen={isUserDrawerOpen} placement="right" onClose={onUserDrawerClose} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader color="#45005E">Organization  Details</DrawerHeader>
          <DrawerBody>
            <Box>
              <Flex gap="2">
                <Tag fontSize={{ sm: "md", md: "lg" }} colorScheme="brand" background={"brand.500"} color="white" fontWeight="bold">Organization Name</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.organizationName}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} colorScheme="brand" background={"brand.500"} color="white" fontWeight="bold">Email</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.phone}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} colorScheme="brand" background={"brand.500"} color="white" fontWeight="bold">Phone</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.phone}</Text>
              </Flex>

            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isOpen} onClose={onClose} size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
            />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid>
              <Box textAlign="center">
                <Heading
                  fontSize={{ base: "md", sm: "lg", md: "lg", lg: "xl" }}
                >
                  Are you sure you want to delete this?
                </Heading>
              </Box>
            </SimpleGrid>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              No
            </Button>
            <Button
              variant="primary"
              background="#000000"
              isLoading={loading}
              loadingText="Please Wait"
              onClick={(e) => {
                e.preventDefault();
                deleteUser();
              }}
            >
              Proceed
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Box mt={{ sm: "40px", md: "80px" }} width="100%" mb="70">
        <Text
          color={"black"}
          mb="4px"
          fontFamily={"ManropeSemiBold"}
          fontSize={{ sm: "md", md: "lg" }}> {organizations.length} Organizations
        </Text>
      </Box>

      <SimpleGrid
        columns={{ sm: 1, md: 2 }}
        w="100%"
        p="2"
        spacing="2"
        mb="4"
      >
        <Box>
          <FormLabel color="black" fontWeight={"bold"}>
            Date
          </FormLabel>
          <InputGroup
            borderRadius={"3em"}
            borderWidth={"1px"}
            borderColor="#8D91A0"
            outlineColor={"black"}>
            <InputLeftElement pointerEvents="none">
              <CalendarIcon color="gray.300" />
            </InputLeftElement>
            <Input
              borderWidth={"0px"}
              type="date"
              placeHolder="Date From"
              color="black"
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          </InputGroup>
        </Box>
        <Box width="100%" textAlign="right">

        </Box>
      </SimpleGrid>


      {loading ? (
        <LoadingUsers />
      ) : (
        <TableContainer>
          <Table variant="striped" fontSize={{ sm: "md", md: "lg" }}>
            <Thead>
              <Tr>
                <Th color="#000000">Organization Name</Th>
                <Th color="#000000">Email</Th>
                <Th color="#000000">Phone</Th>
                <Th color="#000000">Balance</Th>
                <Th color="#000000">Date Created</Th>
                {privileges.includes("Admin") &&
                  <Th color="#000000">Action</Th>
                }
              </Tr>
            </Thead>
            <Tbody>
              {organizations &&
                organizations.map((organization) => (
                  <Tr>
                    <Td>{organization.organizationName} </Td>
                    <Td>{organization.email}</Td>
                    <Td>{organization.phone}</Td>
                    <Td>{"NGN "+new Intl.NumberFormat('en-US', { style: 'decimal' }).format(organization.balance)}</Td>
                    <Td>{formatTime(organization.createdAt)}</Td>
                    {privileges.includes("Admin") &&
                      <Td>
                        {" "}
                        <Menu>
                          <MenuButton
                            as={Button}
                            variant="brand"
                            rightIcon={<ChevronDownIcon />}
                          >
                            Action
                          </MenuButton>
                          <MenuList>

                            {/*<MenuItem
                              onClick={() => {
                                setUserId(user._id);
                                //setUser(user);
                                onOpen();
                              }}
                            >
                              <Icon
                                as={MdDelete}
                                width="20px"
                                height="20px"
                                color="black"
                              />&nbsp;Delete &nbsp;{" "}
                            </MenuItem>*/}
                            <MenuItem
                              onClick={() => {
                                setOrganization(organization);
                                onUserDrawerOpen();
                              }}>
                              <Icon
                                as={FiEye}
                                width="20px"
                                height="20px"
                                color="black"
                              />&nbsp; View &nbsp;{" "}
                            </MenuItem>

                          </MenuList>
                        </Menu>
                      </Td>
                    }
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}

    </>
  );
};


const LoadingUsers = () => {
  return (
    <>
      <Card align="center" p="5px">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>

      <Card align="center" p="5px" mt="5">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>
    </>
  );
};